<template>
    <div class="categoryLabel">
      <span>
        {{ name }}
      </span>
    </div>
</template>

<script>
export default {
  name: "CategoryLabel",

  props: {
    name: String
  },
}
</script>

<style lang="scss" scoped>
.categoryLabel {
  border-radius: $radius-m;
  font-size: 40px;
  margin: 16px 0px;
  background-color: $c-background-1;
  text-align: center;
  height: 80px;

  span {
    font-family: 'Bebas Neue', sans-serif;
    font-weight: 400;
    line-height: 80px;
    color: $c-primary;
    font-size: 50px;
    width: auto;
    height: auto;
  }
}

.categoryLabel:first-child {
  margin-top: 8px;
}
</style>